module.exports = __webpack_public_path__ + "assets/5c7ec2e5fea2e69108c846bf30ddc357.png";